module.exports = __webpack_public_path__ + "static/media/doctor1.1e9cf55c.jpg";